import { callWp } from '../util/call-wp';
import { log } from '../util/log';

document.addEventListener('DOMContentLoaded', loadVerificationPage);

async function loadVerificationPage() {
	const root = document.getElementById('snb-activation-root') as HTMLElement;
	if (!root) {
		console.log('Verification element not found');
		log('Verification element not found');
		return;
	}

	const texts = root.querySelectorAll<HTMLElement>('[data-text]')!;
	const textsAfterSend = root.querySelectorAll<HTMLElement>('[data-text-after-send]')!;
	const loader = root.querySelector<HTMLDivElement>('[data-loader]')!;
	const sendButton = root.querySelector<HTMLButtonElement>('[data-send]')!;
	const codeInput = root.querySelector<HTMLInputElement>('[data-code]')!;
	const verifyButton = root.querySelector<HTMLButtonElement>('[data-verify]')!;
	const successMessage = root.querySelector<HTMLButtonElement>('[data-success]')!;
	const errorMessage = root.querySelector<HTMLButtonElement>('[data-error]')!;
	const resendContainer = root.querySelector<HTMLDivElement>('[data-resend]')!;
	const resendText = root.querySelector<HTMLSpanElement>('[data-resend-text]')!;
	const resendCountdown = root.querySelector<HTMLSpanElement>('[data-countdown]')!;
	const resendButton = root.querySelector<HTMLButtonElement>('[data-resend-button]')!;
	const title = document.querySelector<HTMLElement>('.verify__title')!;
	const address = document.querySelector<HTMLElement>('.verify__address')!;

	// Check if the user is verified
	const responseA = await callWp('GET', 'check_verification');
	console.log(responseA.data);

	const { verified, codeSent, cooldown, referenceTime } = responseA.data;

	loader.style.display = 'none';

	if (verified) {
		successMessage.style.display = 'flex';

		texts.forEach((text) => (text.style.display = 'none'));
		textsAfterSend.forEach((text) => (text.style.display = 'none'));
		loader.style.display = 'none';
		sendButton.style.display = 'none';
		codeInput.style.display = 'none';
		verifyButton.style.display = 'none';
		errorMessage.style.display = 'none';
		resendContainer.style.display = 'none';

		// If there is a booking local storage key, redirect to booking
		const localStorageKey = 'silk-nexus-wp-booking-data';
		if (localStorage.getItem(localStorageKey)) {
			window.location.href = window.location.href + '?redirect_to_booking=1';
		}
		return;
	}

	if (!codeSent) {
		texts.forEach((text) => (text.style.display = 'flex'));
		sendButton.style.display = 'flex';

		sendButton.addEventListener('click', async () => {
			sendButton.style.display = 'none';
			loader.style.display = 'flex';

			const responseB = await callWp('POST', 'send_verification');
			console.log(responseB);

			loader.style.display = 'none';

			const { cooldown: cd, referenceTime: rt } = responseB.data;
			restartCountdown(rt, cd, showResendButton);

			textsAfterSend.forEach((text) => (text.style.display = 'flex'));
			codeInput.style.display = 'flex';
			verifyButton.style.display = 'flex';
			resendContainer.style.display = 'flex';
			title.style.display = 'none';
			address.style.display = 'none';

			const event = new CustomEvent('code-sent', { detail: { sent: true } });
			document.dispatchEvent(event);
		});
	} else {
		textsAfterSend.forEach((text) => (text.style.display = 'flex'));
		codeInput.style.display = 'flex';
		verifyButton.style.display = 'flex';
		resendContainer.style.display = 'flex';
		title.style.display = 'none';
		address.style.display = 'none';
	}

	codeInput.addEventListener('input', () => {
		if (codeInput.value.length > 6) {
			codeInput.value = codeInput.value.slice(0, 6);
		}

		codeInput.value = codeInput.value.replace(/[^0-9]/g, '');

		verifyButton.disabled = codeInput.value.length !== 6;
	});

	verifyButton.addEventListener('click', async () => {
		verifyButton.style.display = 'none';
		errorMessage.style.display = 'none';
		loader.style.display = 'flex';

		codeInput.disabled = true;

		const code = codeInput.value;
		const responseC = await callWp('POST', 'verify_code', { code });
		console.log(responseC);

		loader.style.display = 'none';

		if (responseC.data.verified) {
			successMessage.style.display = 'flex';

			texts.forEach((text) => (text.style.display = 'none'));
			textsAfterSend.forEach((text) => (text.style.display = 'none'));
			loader.style.display = 'none';
			sendButton.style.display = 'none';
			codeInput.style.display = 'none';
			verifyButton.style.display = 'none';
			errorMessage.style.display = 'none';
			resendContainer.style.display = 'none';

			// add an event that can be triggered when the user is verified
			const event = new CustomEvent('user-verified', { detail: { verified: true } });
			document.dispatchEvent(event);

			// If there is a booking local storage key, redirect to booking
			const localStorageKey = 'silk-nexus-wp-booking-data';
			if (localStorage.getItem(localStorageKey)) {
				window.location.href = window.location.href + '?redirect_to_booking=1';
			} else {
				window.location.reload();
			}
		} else {
			errorMessage.innerText = responseC.data.message;
			errorMessage.style.display = 'flex';
			verifyButton.style.display = 'flex';
			codeInput.disabled = false;

			const event = new CustomEvent('user-verified', { detail: { verified: false } });
			document.dispatchEvent(event);
		}
	});

	function showResendButton() {
		console.log('showResendButton');
		resendText.style.display = 'none';
		resendCountdown.style.display = 'none';
		resendButton.style.display = 'flex';
	}

	resendButton.addEventListener('click', async () => {
		resendButton.style.display = 'none';
		loader.style.display = 'flex';

		const responseD = await callWp('POST', 'send_verification');

		const { cooldown: cd, referenceTime: rt } = responseD.data;

		console.log(responseD);

		loader.style.display = 'none';
		hideResendButton();

		restartCountdown(rt, cd, showResendButton);
	});

	function hideResendButton() {
		resendText.style.display = 'flex';
		resendCountdown.style.display = 'flex';
		resendButton.style.display = 'none';
	}

	restartCountdown(referenceTime, cooldown, showResendButton);

	// Resend countdown

	let interval: NodeJS.Timer | null = null;

	function restartCountdown(reftimestamp: number, expires: number, callback: () => void) {
		const refTime = new Date(reftimestamp * 1000);
		const ref = refTime.getTime();
		const nowTime = new Date();
		const now = nowTime.getTime();

		const expiresDate = new Date(expires * 1000);

		const timeDiff = now - ref;

		const updateTimer = () => {
			if (!resendCountdown.isConnected) {
				if (interval) clearInterval(interval);
				// return;
			}

			const nowDate = new Date();

			const diff = -(nowDate.getTime() + timeDiff - expiresDate.getTime());

			if (diff <= 0) {
				if (interval) clearInterval(interval);
				resendCountdown.textContent = '0:00';
				callback();
				return;
			}

			const minutes = Math.floor(diff / 1000 / 60);
			const seconds = Math.floor((diff / 1000) % 60);

			resendCountdown.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
		};

		if (interval) {
			clearInterval(interval);
		}
		interval = setInterval(() => updateTimer(), 500);
		updateTimer();
	}
}
